document.addEventListener("DOMContentLoaded", function () {
  function isMobileDevice() {
    return /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
  }

  function hasNewTemplate() {
    // Check if body has any class containing "template-" and "new"
    const bodyClasses = Array.from(document.body.classList);
    return bodyClasses.some(
      (className) =>
        className.includes("template-") && className.includes("new")
    );
  }

  function getNewTemplateClass() {
    // Get the first template class that contains "new"
    const bodyClasses = Array.from(document.body.classList);
    return bodyClasses.find(
      (className) =>
        className.includes("template-") && className.includes("new")
    );
  }

  function checkRequiredElements(templateClass) {
    // Check if the necessary elements exist in the DOM
    const imageSlide = document.querySelector(
      `.${templateClass} .image__slide`
    );
    const imageSlidesContainer = document.querySelector(
      `.${templateClass} .image__slides`
    );

    if (!imageSlide) {
      console.warn(
        `Mobile slides: .image__slide not found for ${templateClass}`
      );
      return false;
    }

    if (!imageSlidesContainer) {
      console.warn(
        `Mobile slides: .image__slides container not found for ${templateClass}`
      );
      return false;
    }

    return { imageSlide, imageSlidesContainer };
  }

  function handleMobileImageSlides() {
    // Only proceed if we have a "new" template
    if (!hasNewTemplate()) {
      return;
    }

    const templateClass = getNewTemplateClass();
    if (!templateClass) {
      return;
    }

    // Check if required elements exist
    const elements = checkRequiredElements(templateClass);
    if (!elements) {
      return;
    }

    const { imageSlide, imageSlidesContainer } = elements;

    // Check if we should show mobile version (small screen AND mobile device)
    const shouldShowMobile = window.innerWidth <= 500 && isMobileDevice();

    if (shouldShowMobile) {
      // Add clones for mobile if not already done
      if (!imageSlidesContainer.dataset.cloned) {
        // Clone the original slide 3 times for marquee effect
        for (let i = 0; i < 3; i++) {
          const copy = imageSlide.cloneNode(true);
          imageSlidesContainer.appendChild(copy);
        }
        imageSlidesContainer.dataset.cloned = "true";
        console.log(`Mobile slides: Clones added for ${templateClass}`);
      }
    } else {
      // Remove clones for desktop/larger screens
      if (imageSlidesContainer.dataset.cloned) {
        // Remove the cloned elements (keep only the original)
        const slides = imageSlidesContainer.querySelectorAll(".image__slide");
        for (let i = 1; i < slides.length; i++) {
          slides[i].remove();
        }
        delete imageSlidesContainer.dataset.cloned;
        console.log(`Mobile slides: Clones removed for ${templateClass}`);
      }
    }
  }

  // Initial call
  handleMobileImageSlides();

  // Handle resize events with debouncing
  let resizeTimeout;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(handleMobileImageSlides, 250);
  });
});
